export default "__VITE_ASSET__dca4b12d__"